import jwt_decode from 'jwt-decode'

var billable = {}

// Lazy import to avoid circular dependency
async function setupBillableSubscription() {
  try {
    const { authenticationService } = await import('@enkla-gui')


    // Set up subscription
    authenticationService?.currentToken?.subscribe(x => {
      if (x?.access_token) {
        try {
          var token = jwt_decode(x.access_token)
          billable = token?.billable || {}
          if (token?.boarded !== undefined) {
            billable.boarded = token.boarded
          }
        } catch (error) {
          billable = {}
        }
      } else {
        billable = {}
      }
    })

    // Also check current token value
    if (authenticationService?.currentTokenValue?.access_token) {
      try {
        const token = jwt_decode(authenticationService.currentTokenValue.access_token)
        billable = token?.billable || {}
        if (token?.boarded !== undefined) {
          billable.boarded = token.boarded
        }
      } catch (error) {
        console.error('Initial token decode error:', error)
      }
    }

  } catch (error) {
    console.error('Failed to load authenticationService:', error)
  }
}

// Set up the subscription after a microtask to ensure all modules are loaded
Promise.resolve().then(setupBillableSubscription)

export { billable }
